module.exports = __webpack_public_path__ + "img/yangchun-hospital-qr.f84ef258.png";